module.exports = __webpack_public_path__ + "static/media/tou-085.51a48aff.png";